import NotificationType from '../NotificationType';

export default class ReimbursementRequestSigningAuthorityApproval extends NotificationType {
  get icon() {
    return 'fa-solid fa-money-check-dollar';
  }

  resolveRoute(notification) {
    const rmbId = notification.params?.reimbursement_request_id;
    const clubId = notification.params?.club_id;
    if (!rmbId || !clubId) return null;

    return { name: 'show-reimbursement-request', params: { id: clubId, rmbId } };
  }
}
